(function() {
  'use strict';

  class EcHeroBanner {
    constructor() {
      this.currentSlide = 0;
      this.autoPlayInterval = null;
      this.init();
    }

    init() {
      this.setupElements();
      this.bindEvents();
      this.showSlide(0);
      this.startAutoPlay();
    }

    setupElements() {
      this.banners = document.querySelectorAll('.ec-hero-banner');

      this.banners.forEach(banner => {
        banner.slidesContainer = banner.querySelector('.ec-hero-banner__slides');
        banner.slides = banner.querySelectorAll('.ec-hero-banner__slide');
        banner.dots = banner.querySelectorAll('.ec-hero-banner__dot');
        banner.prevBtn = banner.querySelector('.ec-hero-banner__arrow--prev');
        banner.nextBtn = banner.querySelector('.ec-hero-banner__arrow--next');
        banner.sectionId = banner.getAttribute('data-section-id');

        if (banner.slides.length === 0) return;

        if (banner.slides.length > 0) {
          banner.slides[0].classList.add('is-active');
        }
        if (banner.dots.length > 0) {
          banner.dots[0].classList.add('is-active');
        }
      });
    }

    bindEvents() {
      this.banners.forEach(banner => {
        let touchStartX = 0;
        let touchStartY = 0;
        let isDragging = false;

        const handleDragStart = (e) => {
          isDragging = true;
          touchStartX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
          touchStartY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
          banner.slidesContainer.style.cursor = 'grabbing';
        };

        const handleDragEnd = (e) => {
          if (!isDragging) return;
          isDragging = false;
          banner.slidesContainer.style.cursor = 'default';

          const touchEndX = e.type.includes('mouse') ? e.clientX : e.changedTouches[0].clientX;
          const diff = touchStartX - touchEndX;
          const threshold = 50;

          if (Math.abs(diff) > threshold) {
            if (diff > 0) {
              this.nextSlide(banner);
            } else {
              this.previousSlide(banner);
            }
          }
        };

        banner.slidesContainer.addEventListener('mousedown', handleDragStart);
        banner.slidesContainer.addEventListener('mouseup', handleDragEnd);
        banner.slidesContainer.addEventListener('mouseleave', handleDragEnd);

        banner.slidesContainer.addEventListener('touchstart', handleDragStart, { passive: true });
        banner.slidesContainer.addEventListener('touchend', handleDragEnd, { passive: true });

        if (banner.prevBtn) {
          banner.prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.previousSlide(banner);
          });
        }

        if (banner.nextBtn) {
          banner.nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.nextSlide(banner);
          });
        }

        banner.dots.forEach((dot, index) => {
          dot.addEventListener('click', (e) => {
            e.preventDefault();
            this.goToSlide(banner, index);
          });
        });
      });
    }

    showSlide(index, banner, direction = 'next') {
      if (!banner) {
        this.banners.forEach(b => this.showSlide(index, b, direction));
        return;
      }

      if (index < 0 || index >= banner.slides.length) return;

      banner.slides.forEach(slide => {
        slide.classList.remove('is-active', 'is-prev');
      });
      banner.dots.forEach(dot => dot.classList.remove('is-active'));

      const currentSlide = banner.slides[banner.currentSlide];
      if (direction === 'prev') {
        currentSlide.classList.add('is-prev');
      }

      banner.slides[index].classList.add('is-active');
      banner.dots[index].classList.add('is-active');

      banner.currentSlide = index;
    }

    nextSlide(banner) {
      const nextIndex = (banner.currentSlide + 1) % banner.slides.length;
      this.goToSlide(banner, nextIndex, 'next');
    }

    previousSlide(banner) {
      const prevIndex = (banner.currentSlide - 1 + banner.slides.length) % banner.slides.length;
      this.goToSlide(banner, prevIndex, 'prev');
    }

    goToSlide(banner, index, direction = 'next') {
      this.showSlide(index, banner, direction);
      this.resetAutoPlay(banner);
    }

    startAutoPlay() {
      this.banners.forEach(banner => {
        const slidesContainer = banner.querySelector('.ec-hero-banner__slides');
        if (!slidesContainer) return;

        const autoPlay = slidesContainer.getAttribute('data-autoplay') === 'true';
        if (!autoPlay) return;

        const speed = parseInt(slidesContainer.getAttribute('data-speed') || '5', 10) * 1000;

        banner.autoPlayInterval = setInterval(() => {
          this.nextSlide(banner);
        }, speed);
      });
    }

    resetAutoPlay(banner) {
      if (banner.autoPlayInterval) {
        clearInterval(banner.autoPlayInterval);
      }
      this.startAutoPlay();
    }

    destroy() {
      this.banners.forEach(banner => {
        if (banner.autoPlayInterval) {
          clearInterval(banner.autoPlayInterval);
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.ecHeroBanner = new EcHeroBanner();
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
      if (window.ecHeroBanner) {
        window.ecHeroBanner.destroy();
      }
      window.ecHeroBanner = new EcHeroBanner();
    });
  }
})();
